"use strict";

var _interopRequireDefault = require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.buildMenus = buildMenus;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.getMenusTree = getMenusTree;
var _request = _interopRequireDefault(require("@/utils/request"));
function getMenusTree() {
  return (0, _request.default)({
    url: 'api/menus/tree',
    method: 'get'
  });
}
function buildMenus() {
  return (0, _request.default)({
    url: 'api/menus/build',
    method: 'get'
  });
}
function add(data) {
  return (0, _request.default)({
    url: 'api/menus',
    method: 'post',
    data: data
  });
}
function del(ids) {
  return (0, _request.default)({
    url: 'api/menus',
    method: 'delete',
    data: ids
  });
}
function edit(data) {
  return (0, _request.default)({
    url: 'api/menus',
    method: 'put',
    data: data
  });
}
var _default = exports.default = {
  add: add,
  edit: edit,
  del: del,
  getMenusTree: getMenusTree
};